export function isImageOnlyHtml(html: string): boolean {
  const stripped = html
    .replace(/<meta[^>]*>/gi, '')
    .replace(/<!--[\s\S]*?-->/g, '')
    .trim();
  return /^<img\b[^>]*>$/i.test(stripped);
}
